import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal fade show",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "modal-dialog wise-modal" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "d-flex for-dialog" }
const _hoisted_8 = { class: "dlg-strong-title" }
const _hoisted_9 = { class: "dlg-span-data flex-fill" }
const _hoisted_10 = { class: "fs-6 my-3" }
const _hoisted_11 = { class: "d-flex flex-column px-3" }
const _hoisted_12 = { class: "form-check" }
const _hoisted_13 = {
  class: "form-check-label",
  for: "StylePrint1"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye" }, null, -1)
const _hoisted_15 = { class: "form-check" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  class: "form-check-label",
  for: "StylePrint2"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-word" }, null, -1)
const _hoisted_19 = { class: "form-check" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  class: "form-check-label",
  for: "StylePrint3"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-excel" }, null, -1)
const _hoisted_23 = { class: "form-check" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  class: "form-check-label",
  for: "StylePrint4"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-pdf" }, null, -1)
const _hoisted_27 = { class: "form-check" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  class: "form-check-label",
  for: "StylePrint5"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-image" }, null, -1)
const _hoisted_31 = { class: "form-check" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  class: "form-check-label",
  for: "StylePrint6"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope-at-fill" }, null, -1)
const _hoisted_35 = {
  key: 0,
  class: "fs-6 my-2"
}
const _hoisted_36 = {
  for: "EmailReceiver",
  class: "form-label"
}
const _hoisted_37 = ["placeholder", "disabled"]
const _hoisted_38 = {
  for: "EmailSubject",
  class: "form-label"
}
const _hoisted_39 = ["placeholder", "disabled"]
const _hoisted_40 = {
  for: "EmailMessage",
  class: "form-label"
}
const _hoisted_41 = ["placeholder", "disabled"]
const _hoisted_42 = { class: "modal-footer" }
const _hoisted_43 = { class: "d-flex justify-content-end" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.language.printing_system), 1),
              (!_ctx.isPrinting)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeFormRet && _ctx.closeFormRet(...args))),
                    type: "button",
                    class: "btn-close"
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("strong", _hoisted_8, _toDisplayString(_ctx.language.title), 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.dataRecord.ReportTitle), 1)
              ]),
              _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.language.print_options), 1),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "StylePrint",
                    id: "StylePrint1",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataRecord.StylePrint) = $event)),
                    value: "1",
                    disabled: true
                  }, null, 512), [
                    [_vModelRadio, _ctx.dataRecord.StylePrint]
                  ]),
                  _createElementVNode("label", _hoisted_13, [
                    _hoisted_14,
                    _createTextVNode(" " + _toDisplayString(_ctx.language.print_prev), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "StylePrint",
                    id: "StylePrint2",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataRecord.StylePrint) = $event)),
                    value: "2",
                    disabled: _ctx.isPrinting
                  }, null, 8, _hoisted_16), [
                    [_vModelRadio, _ctx.dataRecord.StylePrint]
                  ]),
                  _createElementVNode("label", _hoisted_17, [
                    _hoisted_18,
                    _createTextVNode(" " + _toDisplayString(_ctx.language.export_to_msword), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "StylePrint",
                    id: "StylePrint3",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataRecord.StylePrint) = $event)),
                    value: "3",
                    disabled: _ctx.isPrinting
                  }, null, 8, _hoisted_20), [
                    [_vModelRadio, _ctx.dataRecord.StylePrint]
                  ]),
                  _createElementVNode("label", _hoisted_21, [
                    _hoisted_22,
                    _createTextVNode(" " + _toDisplayString(_ctx.language.export_to_msexcel), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "StylePrint",
                    id: "StylePrint4",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataRecord.StylePrint) = $event)),
                    value: "4",
                    disabled: _ctx.isPrinting
                  }, null, 8, _hoisted_24), [
                    [_vModelRadio, _ctx.dataRecord.StylePrint]
                  ]),
                  _createElementVNode("label", _hoisted_25, [
                    _hoisted_26,
                    _createTextVNode(" " + _toDisplayString(_ctx.language.export_to_pdf), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "StylePrint",
                    id: "StylePrint5",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataRecord.StylePrint) = $event)),
                    value: "5",
                    disabled: _ctx.isPrinting
                  }, null, 8, _hoisted_28), [
                    [_vModelRadio, _ctx.dataRecord.StylePrint]
                  ]),
                  _createElementVNode("label", _hoisted_29, [
                    _hoisted_30,
                    _createTextVNode(" " + _toDisplayString(_ctx.language.export_to_image), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "StylePrint",
                    id: "StylePrint6",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dataRecord.StylePrint) = $event)),
                    value: "6",
                    disabled: _ctx.isPrinting
                  }, null, 8, _hoisted_32), [
                    [_vModelRadio, _ctx.dataRecord.StylePrint]
                  ]),
                  _createElementVNode("label", _hoisted_33, [
                    _hoisted_34,
                    _createTextVNode(" " + _toDisplayString(_ctx.language.send_email), 1)
                  ])
                ]),
                (_ctx.dataRecord.StylePrint == 6)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_35, _toDisplayString(_ctx.language.compose_email_content), 1))
                  : _createCommentVNode("", true),
                (_ctx.dataRecord.StylePrint == 6)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["mb-3 not-error-apply", {'has-error': !_ctx.formChecker.isEmailValid}])
                    }, [
                      _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.language.email_recipient), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "email",
                        class: "form-control",
                        id: "EmailReceiver",
                        placeholder: '(' + _ctx.language.email_recipient.toLowerCase() +  ')',
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dataRecord.EmailReceiver) = $event)),
                        disabled: _ctx.isPrinting,
                        onFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectOnFocus($event)))
                      }, null, 40, _hoisted_37), [
                        [_vModelText, _ctx.dataRecord.EmailReceiver]
                      ])
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.dataRecord.StylePrint == 6)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: _normalizeClass(["mb-3 not-error-apply", {'has-error': !_ctx.formChecker.isSubjectValid}])
                    }, [
                      _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.language.email_subject), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "EmailSubject",
                        placeholder: '(' + _ctx.language.email_subject.toLowerCase() +  ')',
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dataRecord.EmailSubject) = $event)),
                        disabled: _ctx.isPrinting,
                        onFocus: _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectOnFocus($event)))
                      }, null, 40, _hoisted_39), [
                        [_vModelText, _ctx.dataRecord.EmailSubject]
                      ])
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.dataRecord.StylePrint == 6)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: _normalizeClass(["mb-3 not-error-apply", {'has-error': !_ctx.formChecker.isContentValid}])
                    }, [
                      _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.language.email_content), 1),
                      _withDirectives(_createElementVNode("textarea", {
                        class: "form-control",
                        id: "EmailMessage",
                        placeholder: '(' + _ctx.language.email_content.toLowerCase() +  ')',
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dataRecord.EmailMessage) = $event)),
                        onFocus: _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectOnFocus($event))),
                        disabled: _ctx.isPrinting,
                        rows: 3
                      }, null, 40, _hoisted_41), [
                        [_vModelText, _ctx.dataRecord.EmailMessage]
                      ])
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary me-2",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.closeFormRet && _ctx.closeFormRet(...args))),
                  disabled: _ctx.isPrinting
                }, _toDisplayString(_ctx.language.close), 9, _hoisted_44),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.printRecordData && _ctx.printRecordData(...args))),
                  disabled: _ctx.isPrinting || !_ctx.formChecker.isformValid
                }, [
                  (_ctx.isPrinting)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 0,
                        icon: ['fa', 'fa-spinner']
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.isPrinting)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 1,
                        icon: ['fa', 'fa-print']
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode("  " + _toDisplayString(_ctx.language.print), 1)
                ], 8, _hoisted_45)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}